import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../navbar/navbar";
import Footer from "../footer/footer";

function Layout({ children }) {
  const [navbarHeight, setNavbarHeight] = useState(0);
   const location = useLocation();

  useEffect(() => {
    const updateNavbarHeight = () => {
      const navbar = document.querySelector(".navbar"); // Ensure navbar has this class
      if (navbar) {
        setNavbarHeight(navbar.offsetHeight);
      }
    };

    updateNavbarHeight(); // Run initially
    window.addEventListener("resize", updateNavbarHeight);

    return () => {
      window.removeEventListener("resize", updateNavbarHeight);
    };
  }, []);

   useEffect(() => {
    window.scrollTo(0, 0); 
  }, [location.pathname]);

  return (
      <>
      <Navbar />
      <div style={{ paddingTop: `${navbarHeight}px` }}>
        {children}
      </div>
      <Footer />
      </>
  );
}

export default Layout;
